export const isRolesDifferent = (contactRoles: string[], newHpRoles: string[]) => {
  const baseRoles = new Set(contactRoles)
  const newRoles = new Set(newHpRoles)

  return baseRoles.size !== newRoles.size || [...baseRoles].some((role) => !newRoles.has(role))
}
